import React, { useCallback, useState } from "react";
import debounce from "lodash.debounce";
import { FiSearch } from "react-icons/fi"; // React search icon

const DebounceSmallSearchInput = ({
  handleSearchChange,
  placeholder = "Search...",
}) => {
  const [inputValue, setInputValue] = useState("");

  const debouncedSearch = useCallback(
    debounce((value) => {
      handleSearchChange(value);
    }, 300),
    [handleSearchChange]
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    debouncedSearch(value);
  };



  return (
    <div className="position-relative" style={{ maxWidth: 180 }}>
      {/* Search Icon */}
      <FiSearch
        className="position-absolute top-50 start-0 translate-middle-y ms-2 text-secondary"
        style={{ fontSize: "1rem" }}
      />
      {/* Input */}
      <input
        type="search"
        name="search"
        className="form-control form-control-sm rounded-2 shadow-sm ps-5 pe-4 py-1"
        placeholder={placeholder}
        value={inputValue}
        onChange={handleInputChange}
        style={{ fontSize: "0.85rem" }}
      />
    </div>
  );
};

export default DebounceSmallSearchInput;
